module.exports = __webpack_public_path__ + "static/media/bg_1.8446bd70.png";